import { HttpErrorResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { CommonsHttpService } from '@qaroni-core/services/commons/commons-http/commons-http.service';
import { TimezoneCheckResult } from '@qaroni-core/types/timezone/timezone-check-result';
import { TimezoneApiResponse } from '@qaroni-core/types/timezone/timezone-response';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { TimezoneHttpService } from './timezone-http.service';

@Injectable({
  providedIn: 'root',
})
export class TimezoneService {
  private http = inject(TimezoneHttpService);
  private commonsHttp = inject(CommonsHttpService);

  protected readonly timezonesSubject = new BehaviorSubject<string[]>(null);
  private timezones: string[];

  public checkTimezone(timezone: string): Observable<TimezoneCheckResult> {
    const timezones = this.timezones?.filter(t => t === timezone);
    return of({
      result: timezones?.length ? true : false,
    });
  }

  public getTimezones$(): Observable<string[]> {
    return this.timezonesSubject.asObservable().pipe(shareReplay(1));
  }

  private canReturnTimezones(): boolean {
    return this.timezones?.length ? true : false;
  }

  public getAllTimezones(): void {
    if (this.canReturnTimezones()) {
      this.timezonesSubject.next(this.timezones);
    } else {
      this.http.getAllTimezones$().subscribe({
        next: this.nextGetAllTimezones,
        error: this.errorGetAllTimezones,
      });
    }
  }

  private nextGetAllTimezones = (data: TimezoneApiResponse): void => {
    if (
      this.commonsHttp.validationsHttp.verifyStatus200(data) &&
      data?.body?.result?.length
    ) {
      this.timezones = data?.body?.result;
      this.timezonesSubject.next(this.timezones);
    } else {
      this.timezonesSubject.next(null);
      this.commonsHttp.errorsHttp.apiInvalidResponse(data);
    }
  };

  private errorGetAllTimezones = (error: HttpErrorResponse): void => {
    this.timezonesSubject.next(null);
    this.commonsHttp.errorsHttp.communication(error);
  };
}
